/**
 * Guessing a column's type from a CSV preview (DESIGN_EDITING.md console flow 3). A type is guessed only when every
 * non-empty preview value fits it, so a zip code, 007 or a phone number stays Text. No imports (dataView.ts says why).
 */
import { TypeToken } from './tableName';

const isWholeNumber = (v: string): boolean => /^-?(0|[1-9][0-9]{0,14})$/.test(v); // up to 15 digits, no leading zero
const isDecimal = (v: string): boolean => /^-?(0|[1-9][0-9]*)\.[0-9]+$/.test(v) || /^-?\.[0-9]+$/.test(v);
const isYesNo = (v: string): boolean => /^(true|false|yes|no)$/i.test(v);
const isDate = (v: string): boolean => /^\d{4}-\d{2}-\d{2}$/.test(v);
const isDateTime = (v: string): boolean => /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}(:\d{2})?([.][0-9]+)?(Z|[+-]\d{2}:?\d{2})?$/.test(v);

/**
 * The column's type from its preview values: Number, Decimal, Yes/No, Date, Date and time, else Text. Every non-empty
 * value must fit; with no non-empty values, Text. A value that fits Number also fits Decimal, so Number is tried first.
 */
export const guessType = (values: string[]): TypeToken => {
    const vals = values.filter((v) => v !== '');
    if (vals.length === 0) return 'text';
    const all = (fn: (v: string) => boolean) => vals.every(fn);
    if (all(isWholeNumber)) return 'bigint';
    if (all((v) => isWholeNumber(v) || isDecimal(v))) return 'numeric';
    if (all(isYesNo)) return 'boolean';
    if (all(isDate)) return 'date';
    if (all(isDateTime)) return 'timestamptz';
    return 'text';
};
